import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getGoldenSettingsValidationRules } from '@api/goldenSettings';

import { EValidationRuleType, getTreeNodeValidation } from '@utils/treeValidation';

import { ITreeValidationDTO, TGoldenSettingsValidationRulesDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';
import { IGoldenSettingsValidationRules } from '@interfaces/cmModule/goldenSettings';

import { GOLDEN_SETTING_VALIDATION_RULES } from '@constants/queryKeys';

interface IUseMutateGoldenValidationRulesReturnType {
	validationRulesData: IGoldenSettingsValidationRules[];
	getValidationRules: UseMutateAsyncFunction<
		IGoldenSettingsValidationRules[],
		any,
		TGoldenSettingsValidationRulesDTO,
		any
	>;
	isLoadingValidationRules: boolean;
}

const useMutateGoldenValidationRules = (vendor: string): IUseMutateGoldenValidationRulesReturnType => {
	const {
		data,
		isLoading,
		mutateAsync: getValidationRules,
	} = useMutation<TGoldenSettingsValidationRulesDTO, IGoldenSettingsValidationRules[]>({
		mutationKey: [GOLDEN_SETTING_VALIDATION_RULES],
		mutationFn: async ({ nameSpace, name, path }: ITreeValidationDTO) => {
			if (name && nameSpace && vendor) {
				const data = await getGoldenSettingsValidationRules({
					name,
					nameSpace,
					vendor,
					path: path.replace(new RegExp(`/${name}$`), ''),
				});

				return {
					rules: data[0]?.rules,
					validations: getTreeNodeValidation(data[0]?.rules
						.filter(item => item.type.name !== EValidationRuleType.MANDATORY)),
				};
			}
		},
	});

	return {
		validationRulesData: data || [],
		getValidationRules,
		isLoadingValidationRules: isLoading,
	};
};

export default useMutateGoldenValidationRules;
